import BaseForm from "form-backend-validation";

class Form extends BaseForm {
  constructor(data = {}, options = {}) {
    super(data, options);
  }

  withOptions(options) {
    if (Object.hasOwn(options, "useResource")) {
      try {
        options.http = new options.useResource(this.data()).$http;
      } catch {
        options.http = options.useResource._applyInstance(this.data()).$http;
      }
    } else if (!Object.hasOwn(options, "http")) {
      const { $http } = useNuxtApp();
      options.http = $http;
    }
    super.withOptions(options);
    if (Object.hasOwn(options, "useResource")) {
      try {
        this.__options.useResource = new options.useResource(this.data());
      } catch {
        this.__options.useResource = options.useResource;
      }
    }
    return this;
  }

  getModel() {
    if (!this.__options.useResource) {
      throw Error(
        "A resource not supplied in the form options. Unable to save(). Use post(url) or put(url) instead."
      );
    }
    return this.__options.useResource._applyInstance(this.data());
  }

  endpoint() {
    return this.getModel().endpoint();
  }

  save() {
    if (!this.__options.useResource) {
      throw Error(
        "A resource not supplied in the form options. Unable to save(). Use post(url) or put(url) instead."
      );
    }

    const resource = this.getModel();

    return resource.hasId()
      ? this.put(resource.endpoint())
      : this.post(resource.endpoint());
  }

  onSuccess(data) {
    super.onSuccess(data);
    this.setIdFromResponse(data);
  }

  setIdFromResponse(response) {
    if (this.__options.resetOnSuccess) {
      //Form reset means no need to set the ID.
      return;
    }

    if (!this.__options.useResource) {
      // No defined resources mean no need to set the ID.
      return;
    }

    if (response.data) {
      // Look for returned model
      response = response.data;
    }

    const resource = this.__options.useResource;

    if (!response[resource.primaryKey()]) {
      // Couldn't find the primary key in server response.
      return;
    }

    let data = this.data();

    if (data[resource.primaryKey()]) {
      // Data already has primary key assigned
      return;
    }

    data[resource.primaryKey()] = response[resource.primaryKey()];

    this.withData(data);
  }

  /**
   * Handle a failed form submission.
   *
   * @param {object} data
   */
  onFail(error) {
    this.successful = false;

    if (error.response && error.response._data.errors) {
      this.errors.record(error.response._data.errors);
    }
  }

  hasError(field) {
    return super.hasError(field) || undefined;
  }

  hasChanged() {
    return (
      JSON.stringify(this.initial).localeCompare(
        JSON.stringify(this.data())
      ) !== 0
    );
  }
}

export { Form as useForm };
